<template>
  <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>订单</el-breadcrumb-item>
        <el-breadcrumb-item>快递</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col class="'toolbar">
      <el-form :inline="true" size="small" :model="s" class="form-inline">
        <el-form-item label="快递名称">
          <el-input v-model="s.name_contains" placeholder="请输入快递名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="seacrch"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>搜索</el-button>
          <el-button type="success" @click="addShipperDalogVisible = true"><i class="el-icon-circle-plus-outline" style="font-weight: bolder; margin-right: 6px;"></i>新增快递</el-button>
        </el-form-item>
      </el-form>
      <el-dialog :visible.sync="addShipperDalogVisible" :before-close="handleClose" width="30%">
        <span>
            <el-form :model = "loggicsadddata" ref= "loggicsadddata" :rules="rules" label-width="100px" class="laddform">
              <el-form-item label="系统名称" prop="showName" require>
                <el-input v-model="loggicsadddata.showName" placeholder="请输入系统名称"></el-input>
              </el-form-item>
               <el-form-item label="物流品牌">
                <el-select v-model="loggicsadddata.shipperCode" placeholder="请选择物流品牌">
                  <el-option
                    v-for="sp in shipperList"
                    :key="sp.ID"
                    :label="sp.Name"
                    :value="sp.Syscode">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="店铺名称" prop="name" require>
                <el-input v-model="loggicsadddata.name" placeholder="请输入店铺名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="addShipperDalogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addlogtics('loggicsadddata')">确 定</el-button>
              </el-form-item>
            </el-form>
          </span>
      </el-dialog>
    </el-col>
    <el-col>
      <el-row>
        <el-col :span="15">
           <el-col>
            <el-table :data="tableData" @current-change="handleCurrentChange" stripe style="width: 100%">
              <el-table-column prop="ID" label="快递ID" width="100"></el-table-column>
              <el-table-column prop="showName" label="系统名称" width="300"></el-table-column>
              <el-table-column prop="name" label="店铺名称" width="300"></el-table-column>
              <el-table-column prop="status" :formatter="logticsStatus" label="状态" width="100"></el-table-column>
              <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handShippperEgitChange(scope.row)">编辑</el-button>
                  <el-button @click="handleShipperStateChange(scope.row)" type="text" size="small">状态</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-dialog :visible.sync="editShipperalogVisible" :before-close="handleClose" width="30%">
              <span>
                  <el-form :model = "currShipperEdit" ref= "currShipperEdit" :rules="rules" label-width="100px" class="laddform">
                    <el-form-item label="系统名称" prop="showName" require>
                      <el-input v-model="currShipperEdit.showName" placeholder="请输入系统名称"></el-input>
                    </el-form-item>
                     <el-form-item label="物流品牌">
                      <el-select v-model="currShipperEdit.shipperCode" placeholder="请选择物流品牌">
                        <el-option
                          v-for="sp in shipperList"
                          :key="sp.ID"
                          :label="sp.Name"
                          :value="sp.Syscode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="店铺名称" prop="name" require>
                      <el-input v-model="currShipperEdit.name" placeholder="请输入店铺名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="addShipperDalogVisible = false">取 消</el-button>
                      <el-button type="primary" @click="updatelogtics('currShipperEdit')">确 定</el-button>
                    </el-form-item>
                  </el-form>
                </span>
            </el-dialog>
          </el-col>
          <el-col>
            <el-pagination @current-change="logticsNextPage" :current-page="currentPage" :page-size="10" layout="total, prev, pager, next, jumper" :total="pagenav.total">
            </el-pagination>
          </el-col>
        </el-col>
        <el-col :span="9" class="allocationbox">
          <div class="localtitle"><h2>物流分区管理<i v-if="currClickShipper.name" class="curr">当前快递为:{{ currClickShipper.showName }}</i><i class="curr" v-else>未选择快递</i></h2></div>
          <span class="defaultbox" v-if="currClickLocations.length === 0">
            当前无快递分区可用，请先行申请
          </span>
          <span  class="allocation" v-for="location in currClickLocations" :key="location.ID">
            <el-tag size="medium" closable class="tagtarget" type="success" @close="closelocation(location.ID)" v-if="location.status">{{ location.name }}</el-tag>
            <el-tag size="medium" closable class="tagtarget" type="danger" @close="closelocation(location.ID)" v-else>{{ location.name }}</el-tag>
          </span>
          <el-button class="button-new-attribute-value" size="small" @click="addarea">+ 新增分区</el-button>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: 'Shipping',
  data () {
    return {
      s: {},
      addShipperDalogVisible: false,
      editShipperalogVisible: false,
      tableData: [],
      currentPage: 1,
      pagenav: {total: 0},
      loggicsadddata: {},
      rules: {
        showName: [{ required: true, message: '系统名称不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '店铺名称不能为空', trigger: 'blur' }]
      },
      shipperList: [],
      currShipperEdit: {},
      currClickShipper: {},
      currClickLocations: []
    }
  },
  mounted: function () {
    this.logticsNextPage(1)
    this.loadShippers()
  },
  methods: {
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    logticsNextPage (page, num = 15) {
      var data = this.s
      data['method'] = 'order.logicspage'
      data['page'] = page
      data['num'] = num
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.tableData = ret.body.data.data
        that.pagenav = ret.body.data
        that.currentPage = page
      })
    },
    logticsStatus (val) {
      if (val.status) {
        return ('启用')
      } else {
        return ('禁用')
      }
    },
    addlogtics: function (formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          var data = that.loggicsadddata
          data['method'] = 'order.addlogics'
          that.$http.post(that.$apiurl, data).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('快递方式新增成功!')
              that.addShipperDalogVisible = false
              that.logticsNextPage(that.currentPage)
            } else {
              that.$alert('快递方式申请失改，请稍后重试!')
            }
          })
        } else {
          that.$alert('请确认表单是否正确填写!')
        }
      })
    },
    loadShippers: function () {
      var data = {method: 'shop.shippers'}
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.shipperList = ret.body.data.data
      })
    },
    handleShipperStateChange: function (row) {
      var data = {
        sid: row.ID,
        method: 'order.shipperstatus'
      }
      var that = this
      that.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.$message.success('物流状态更新成功!')
          that.logticsNextPage(that.currentPage)
        } else {
          that.$alert('物流状态更新失败，请稍后重试!')
        }
      })
    },
    handShippperEgitChange: function (row) {
      this.currShipperEdit = row
      this.editShipperalogVisible = true
    },
    updatelogtics: function (refName) {
      var data = this.currShipperEdit
      data['method'] = 'order.updateshipper'
      var that = this
      that.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.$message.success('物流更新成功!')
          that.logticsNextPage(that.currentPage)
          that.editShipperalogVisible = false
        } else {
          that.$alert('物流信息更新失败，请稍后重试!')
        }
      })
    },
    handleCurrentChange: function (val) {
      this.currClickShipper = val
      var data = {
        logistics_id: val.ID,
        method: 'order.shippermap'
      }
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        that.currClickLocations = ret.body.data
      })
    },
    addarea: function () {
      if (this.currClickShipper.showName) {
        var that = this
        this.$prompt('请输入分区名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValidator: function (val) {
            if (val !== null) {
              return (true)
            } else {
              return (false)
            }
          },
          inputErrorMessage: '不正确的分区名称'
        }).then(obj => {
          var data = {
            name: obj.value,
            logistics_id: that.currClickShipper.ID,
            method: 'order.addlocation'
          }
          that.$http.post(that.$apiurl, data).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('新的快递分区申请成功!')
              that.handleCurrentChange(that.currClickShipper)
            } else {
              that.$alert('新的快递分区申请失败，请稍后重试!')
            }
          })
        })
      } else {
        this.$alert('请先行选择相应的快递方式!')
      }
    },
    closelocation: function (lid) {
      var data = {
        lid: lid,
        method: 'order.shipperlocationstatus'
      }
      var that = this
      this.$http.post(that.$apiurl, data).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.$message.success('分区状态更新成功!')
          that.handleCurrentChange(that.currClickShipper)
        } else {
          that.$alert('分区状态更新失败，请稍后重试!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/order/Shippers.vue